
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/disclaimer",
      function () {
        return require("private-next-pages/legal/disclaimer.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal/disclaimer"])
      });
    }
  